import {
  MatchIntro,
  ListingIntro,
  RequestFinalise,
  ParticipantTypeQuestion,
  ParticipantManagementQuestion,
  ServiceAmountQuestion,
  ParticipantAgeQuestion,
  ParticipantLocationQuestion,
  OtherInformationQuestion,
  ContactDetailsQuestion,
  ServiceSelectionQuestion,
  ServiceSubsetSelectionQuestion,
  ConsiderationsQuestion,
  RequestComplete,
} from '../content';

export const requestSteps = {
  match: [
    {id: 1, content: MatchIntro},
    {id: 2, content: ParticipantTypeQuestion},
    {id: 3, content: ParticipantAgeQuestion},
    {id: 4, content: ParticipantManagementQuestion},
    {id: 5, content: ServiceSelectionQuestion},
    {id: 6, content: ServiceAmountQuestion},
    {id: 7, content: ParticipantLocationQuestion},
    {id: 8, content: ConsiderationsQuestion},
    {id: 9, content: OtherInformationQuestion},
    {id: 10, content: ContactDetailsQuestion},
    {id: 11, content: RequestFinalise},
    {id: 12, content: RequestComplete},
  ],
  provider: [
    {id: 1, content: ListingIntro},
    {id: 2, content: ServiceSubsetSelectionQuestion},
    {id: 3, content: ServiceAmountQuestion},
    {id: 4, content: ParticipantTypeQuestion},
    {id: 5, content: ParticipantAgeQuestion},
    {id: 6, content: ParticipantManagementQuestion},
    {id: 7, content: ParticipantLocationQuestion},
    {id: 8, content: ConsiderationsQuestion},
    {id: 9, content: OtherInformationQuestion},
    {id: 10, content: ContactDetailsQuestion},
    {id: 11, content: RequestFinalise},
    {id: 12, content: RequestComplete},
  ],
  listing: [
    {id: 1, content: ListingIntro},
    {id: 2, content: ServiceAmountQuestion},
    {id: 3, content: ParticipantTypeQuestion},
    {id: 4, content: ParticipantAgeQuestion},
    {id: 5, content: ParticipantManagementQuestion},
    {id: 6, content: ParticipantLocationQuestion},
    {id: 7, content: ConsiderationsQuestion},
    {id: 8, content: OtherInformationQuestion},
    {id: 9, content: ContactDetailsQuestion},
    {id: 10, content: RequestFinalise},
    {id: 11, content: RequestComplete},
  ],
};
